import { createStore } from "vuex";
import auth from "./modules/auth";
import brand from "./modules/brand";
import profile from "./modules/profile";
import theme from "./modules/theme";
import bot from "./modules/bot";
import reporting from "./modules/reporting";
import price from "./modules/price";
import symbols from "./modules/symbols";
import wallet from "./modules/wallet";

export default createStore({
  modules: {
    auth,
    brand,
    profile,
    theme,
    bot,
    reporting,
    price,
    symbols,
    wallet,
  },
});
